import gql from "graphql-tag";

export const createKnowledgeBaseSectionMutation = gql`
  mutation createKnowledgeBaseSection($name: String!, $visibleForDealers: Boolean, $parentId: ID) {
    createKnowledgeBaseSection(
      name: $name
      visibleForDealers: $visibleForDealers
      parentId: $parentId
    ) {
      id
    }
  }
`;
